export default __webpack_public_path__ + "static/media/m_ceoLandingBanner.b04ac396.png";